import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { DropdownSettings } from '@stackline/angular-multiselect-dropdown';
@Component({
  standalone: false,
    templateUrl: './views/view.html'
})
export class BasicExample implements OnInit {

    itemList = [];
    selectedItems = [];
    settings: DropdownSettings = {};

    constructor(public seotitle: Title, public meta: Meta) { 
        this.seotitle.setTitle('Basic example');
        this.meta.addTags([
            {name: 'description', content:'Basic example of angular multiselect drodown.'}
        ]);
    }
    ngOnInit() {

        this.itemList = [
            { "countryId": 1, "itemName": "Brazil" },
            { "countryId": 2, "itemName": "Argentina" },
            { "countryId": 3, "itemName": "Chile" },
            { "countryId": 4, "itemName": "Canada" },
            { "countryId": 5, "itemName": "Colombia" },
            { "countryId": 6, "itemName": "Brazil" }
        ];

        this.selectedItems = [
            { "countryId": 1, "itemName": "Brazil" },
            { "countryId": 2, "itemName": "Argentina" },
            { "countryId": 3, "itemName": "Chile" },
            { "countryId": 4, "itemName": "Canada" },
            { "countryId": 5, "itemName": "Colombia" }];

        this.settings = {
            text: "Select Countries",
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            classes: "myclass custom-class",
            primaryKey: "countryId",
            enableSearchFilter: true,
            tagToBody: false,
        };
    }
    onItemSelect(item: any) {
        console.log(item);
        console.log(this.selectedItems);
    }
    OnItemDeSelect(item: any) {
        console.log(item);
        console.log(this.selectedItems);
    }
    onSelectAll(items: any) {
        console.log(items);
    }
    onDeSelectAll(items: any) {
        console.log(items);
    }
    cssgist: boolean = false;
    title: string = "Basic example";
    tsgist: string = "CuppaLabs/ee72fbc7b21dad7e4e7664c5b1553235";
    htmlgist: string = "CuppaLabs/eb78d42ab7971fda6493586e329bfdb8";
    tstitle: string = "basic.ts"
    htmltitle: string = "basic.html";
}
